import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=6f959e5f&scoped=true"
import script from "./goodsAdd.vue?vue&type=script&lang=js"
export * from "./goodsAdd.vue?vue&type=script&lang=js"
import style0 from "./goodsAdd.vue?vue&type=style&index=0&id=6f959e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f959e5f",
  null
  
)

export default component.exports